jQuery(document).ready(function() {

    var $content_ep_designer =  $('.content_ep_designer');
    var $images_content_ep = $content_ep_designer.find('.images_content_ep');
    var slickInitialized = false;
    function initSliderContentEp() {
        if (!slickInitialized && $images_content_ep.length) {
            $images_content_ep.slick({
                slidesToShow: 1.6,
                slidesToScroll: 1,
                arrows: false,
                dots: false,
                infinite: false,
                adaptiveHeight: true,
            });
            slickInitialized = true;
        }
    }

    function destroySliderEp() {
        if (slickInitialized && $images_content_ep.hasClass('slick-initialized')) {
            $images_content_ep.slick('unslick');
            slickInitialized = false;
        }
    }

    function handleResizeContentEp() {
        var windowWidth = $(window).width();

        if (windowWidth < 440) {
            initSliderContentEp();
        } else {
            destroySliderEp();
        }
    }

    handleResizeContentEp();
    $(window).on('resize', handleResizeContentEp);

});